@if (isReady && chartType === 'pie') {
    <div class="chart-container pie-chart-container">
        <!-- pie chart - Count -->
        <highcharts-chart style="display: flex" [Highcharts]="Highcharts" [options]="chartOptions"></highcharts-chart>
        <!-- pie chart - Duration -->
        <highcharts-chart style="display: flex" [Highcharts]="Highcharts" [options]="chartOptions2"></highcharts-chart>
    </div>
} 
@if (isReady && chartType !== 'pie') {
    <div class="chart-container">
        <!-- scatter chart - Count or Duration -->
        @if (isHighcharts) {
            <highcharts-chart style="display: flex" [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"></highcharts-chart>
        }
    </div>
}
